import { Field } from 'formik';
import styled, { css } from 'styled-components/macro';

export const ListWrapper = styled.div<{ $direction: 'row' | 'column' }>`
  display: flex;
  flex-direction: ${({ $direction }) => $direction};

  ${({ theme, $direction }) =>
    $direction === 'row'
      ? css`
          gap: ${theme.spacing.one};
          height: 38px;
          margin: 1px 0;
          align-items: center;
        `
      : css`
          gap: ${theme.spacing.one};
        `};
`;

export const RadioButtonIcon = styled.span<{ disabled?: boolean }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;

  width: 1rem;
  height: 1rem;

  border: 1px solid
    ${({ theme, disabled }) => (disabled ? theme.colors.black_40 : theme.colors.black_60)};
  border-radius: 50%;

  background-color: ${({ theme }) => theme.colors.white};

  cursor: pointer;

  &:after {
    position: absolute;

    display: none;

    content: '';
  }
`;

export const RadioButtonWrapper = styled.label<{ disabled?: boolean }>`
  position: relative;

  display: flex;
  align-items: center;
  padding-left: ${({ theme }) => theme.spacing.one_2};

  color: ${({ theme, disabled }) => (disabled ? theme.colors.black_40 : theme.colors.black_100)};
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  font-size: ${({ theme }) => theme.fontSize.md};

  cursor: pointer;

  ${RadioButtonIcon} {
    &:after {
      top: 50%;
      left: 50%;

      width: 0.625rem;
      height: 0.625rem;
      border-radius: 50%;

      background-color: ${({ theme }) => theme.colors.primary};
      transform: translate(-50%, -50%);
    }
  }
`;

export const RadioButtonInput = styled(Field)`
  position: absolute;

  opacity: 0;
  &:checked ~ ${RadioButtonIcon} {
    border: 1px solid ${({ theme }) => theme.colors.primary};

    &:after {
      display: block;
    }
  }
`;
